import { LeadBadge } from "./LeadBadge";
import { LeadActionsMenu } from "./LeadActionsMenu";

interface LeadHeaderProps {
  firstName: string;
  lastName: string;
  leadSource: string;
  onEdit: (e: React.MouseEvent) => void;
  onDelete: () => void;
}

export const LeadHeader = ({
  firstName,
  lastName,
  leadSource,
  onEdit,
  onDelete,
}: LeadHeaderProps) => {
  return (
    <div className="flex justify-between items-start">
      <div className="space-y-2">
        <h4 className="font-medium text-gray-900 text-lg">
          {firstName} {lastName}
        </h4>
        <LeadBadge leadSource={leadSource} />
      </div>
      <LeadActionsMenu onEdit={onEdit} onDelete={onDelete} />
    </div>
  );
};